import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const PendingRounded = ({ size = 24, ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G fill={props.color || '#fff'} clipPath="url(#a)">
      <Path d="M12 4.46c.98 0 1.93.18 2.82.55.49.2.96.46 1.4.76-.3 0-.6 0-.88-.01a.796.796 0 1 0-.11 1.59c.25.02.5.03.75.03.78 0 1.59-.08 2.48-.24.37-.07.64-.38.66-.75.04-.96-.03-1.98-.23-3.1a.792.792 0 0 0-.92-.65c-.44.08-.73.49-.65.92.07.39.12.76.15 1.12a9.09 9.09 0 0 0-5.46-1.81C6.96 2.86 2.86 6.96 2.86 12c0 4.63 3.46 8.53 8.05 9.08h.1c.4 0 .74-.3.79-.71a.8.8 0 0 0-.7-.89c-3.78-.45-6.64-3.67-6.64-7.49 0-4.16 3.38-7.54 7.54-7.54v.01ZM20.34 11.2c-.44 0-.8.36-.8.8 0 .44-.04.91-.12 1.35-.08.43.21.85.64.93.05 0 .1.01.14.01.38 0 .72-.27.79-.66.1-.54.15-1.09.15-1.64 0-.44-.36-.8-.8-.8v.01ZM19.52 15.7a.796.796 0 0 0-1.1.26c-.29.48-.64.92-1.04 1.32-.31.31-.31.82.01 1.13.16.15.36.23.56.23.2 0 .41-.08.57-.24.48-.49.9-1.02 1.26-1.6.23-.38.12-.87-.26-1.1ZM15.09 18.88c-.41.19-.84.33-1.28.44a.81.81 0 0 0-.59.97c.09.36.42.61.78.61.06 0 .13 0 .19-.02a8.63 8.63 0 0 0 1.55-.54c.4-.18.58-.65.4-1.06a.803.803 0 0 0-1.06-.4h.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default PendingRounded
